<template lang="pug">
  div
    Header
    el-main
      router-view(@setUserTel='setUserTel', :userTel='userTel')
</template>

<script>
import Header from './Header.vue'
export default {
  name: 'Login',
  components: {
    Header
  },
  data () {
    return {
      userTel: '',
    }
  },
  methods: {
    setUserTel (data) {
      console.log("setUserTel", data)
      this.userTel = data
    },
  },
}
</script>
<style scoped>
@media (min-width: 900px) {
  .el-form-item {
      margin: 0 6vw;
  }
}
</style>
